/* eslint-disable global-require */

import loadComponent from 'base/loadComponent';

// add js only for casino pages
// TODO(vite-F3): conditional require() — intentionally NOT converted in F0. Both modules have
// module-scope DOM side effects (SingleCasinoTransaction mounts a React root, ScrollableText
// registers a jQuery ready handler), so a static import would run them on non-casino pages of a
// casino-enabled site. Target shape for F3: move the `window.IS_CASINO` guard into each module, or
// expose an exported init() called from here. See f0-js-codemod-report.md.
if (window.IS_CASINO === true) {
    require('../../components/casino/my-account/MyTransactions/SingleCasinoTransaction');
    require('./ScrollableText');
    loadComponent('casino/Homepage/News/News', 'casino-homepage-news');
}
